export default {"src":"/_next/static/media/DDD.08d17633.svg","height":18,"width":18};